export default (subFunnelName) => {
  return {
    'event': 'corp_to_reg_change',
    'funnel_name': 'AMR',
    'sub_funnel_name': subFunnelName,
  };
};